/*
 * @Author: jiangxd
 * @Date: 2021-07-17 16:45:06
 * @LastEditTime: 2021-07-17 16:45:54
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/recuitConfig/blacklistConfig.ts
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import Upload from '@/views/components/upload/upload.vue';
import { noop } from '@/util';

interface dataBlacklist {
  longitude: number;
  latitude: number;
  maxKm: number;
  tipText: string;
  _display: boolean;
  promptPicture: string;
  node: string;
}
@Component({
  components: {
    Upload,
  },
})
export default class Blacklist extends Vue {
  // 数据源
  @Prop({ default: 0 })
    index: number;

  @Prop({ default: () => {} })
    data: dataBlacklist;

  $refs: {
    blacklistConfigForm: ElForm;
  };

  // 上传图片
  public uploadTipSuccess(res: HttpAPIRetItem<any>) {
    this.data.promptPicture = res.content;
  }

  // 点击按钮切换
  changeRadio(i, value) {
    this.data._display === value;
    if (value === 0) {
      this.$set(this.data, 'promptPicture', null);
      this.$refs.blacklistConfigForm.validateField('tipText', noop);
    }
    if (value === 1) {
      // 此处双向数据绑定，先设置图片为空才能保存
      this.$set(this.data, 'promptPicture', null);
      this.$refs.blacklistConfigForm.validateField('promptPicture', noop);
      delete this.data.tipText;
    }
  }

  // 移除提示图片
  public onRemoveInfoImage(i) {
    this.data.promptPicture = '';
  }

  public onDelIndex(index) {
    this.$emit('onDelLimit', index);
  }

  public rules = {
    longitude: [{ required: true, validator: this.validateLongitude, trigger: 'blur' }],
    latitude: [{ required: true, validator: this.validateLatitude, trigger: 'blur' }],
    maxKm: [{ required: true, validator: this.validateMaxKm, trigger: 'blur' }],
    tipText: [{ required: true, validator: this.validateTip, trigger: 'blur' }],
    promptPicture: [{ required: true, validator: this.validatePic, trigger: ['change', 'blur'] }],
  };

  validateLongitude(rule, value, callback) {
    const vNmber = Number(value);
    if ((vNmber > 0 || vNmber < 0 || vNmber === 0) && value !== '') {
      callback();
    } else {
      callback(new Error('请输入数字'));
      return;
    }
  }

  validateLatitude(rule, value, callback) {
    const vNmber = Number(value);
    if ((vNmber > 0 || vNmber < 0 || vNmber === 0) && value !== '') {
      callback();
    } else {
      callback(new Error('请输入数字'));
      return;
    }
  }

  validateMaxKm(rule, value, callback) {
    const vNmber = Number(value);
    if ((vNmber > 0 || vNmber < 0 || vNmber === 0) && value !== '') {
      callback();
    } else {
      callback(new Error('请输入数字'));
      return;
    }
  }

  validateTip(rule, value, callback) {
    if (!value) {
      return callback(new Error('请输入提示信息'));
    } else {
      callback();
    }
  }

  validatePic(rule, value, callback) {
    if (!value) {
      return callback(new Error('请上传图片'));
    } else {
      callback();
    }
  }
}
